import * as React from 'react';
import { connect } from 'react-redux';
import { hideMobileProfile } from '../../actions/profileActions';
import { showRequestDocuments, showBrokerPopup } from '../../actions/modalActions';
import {
    DOC_POLICY_SCHEDULE,
    DOC_CONFIRMATION_OF_COVER,
    DOC_CROSS_BORDER_LETTER,
    DOC_TAX_INVOICE,
    DOC_SUMMARY_OF_COVER,
    DOC_KPPD_COVER,
    DOC_LIFE_POLICY_DOCUMENT,
} from '../../constants/constants';
import './RequestDocuments.css';
import { DASHBOARD } from '../../routes/routes';
import KPBreadCrumb from '../KPBreadCrumb/KPBreadCrumb';
import { postToController } from '../../actions/apiActions';

class RequestDocuments extends React.Component<any, any> {
    constructor(props: any) {
        super(props);

        this.state = {
            viewPersonal: props.profile.isLinked ? true : false,
            viewLife: props.profile.isLifeLinked ? true : false,
            documentList: null,
        };

        this.showAll = this.showAll.bind(this);
        this.showPersonal = this.showPersonal.bind(this);
        this.showLife = this.showLife.bind(this);
        this.showRequestModal = this.showRequestModal.bind(this);
    }

    async componentDidMount() {
        await postToController(this.props.dispatch, 'GetDocumentList', JSON.stringify({})).then(async (response) => {
            let documentList = response.sort((a, b) => a.description.localeCompare(b.description));
            await this.setState({ documentList });
            return true;
        });
        this.props.dispatchHideProfile();
    }

    async showAll() {
        let state = { ...this.state, viewPersonal: false, viewLife: false };
        if (this.props.profile.isLifeLinked) {
            state = {
                ...state,
                viewLife: true
            }
        }
        if (this.props.profile.isLinked) {
            state = {
                ...state,
                viewPersonal: true
            }
        }
        this.setState(state);
    }

    async showRequestModal(e: any) {
        if (this.props.profile.broker === "" || this.props.profile.broker === undefined) {
            let value = e;
            var documentId = -1
            if (this.state.documentList) {
                for (var i = 0; i < this.state.documentList.length; i++) {
                    if (this.state.documentList[i]["description"] === value) {
                        documentId = this.state.documentList[i]["id"];
                    }
                }
                this.props.dispatchShowRequestDocuments(value, documentId.toString());
            }
        }
        else {
            this.props.dispatchShowBrokerPopup();
        }
    }

    async showPersonalLife() {
        this.setState({ viewPersonal: true, viewLife: true })
    }

    async showPersonal() {
        this.setState({ viewPersonal: true, viewLife: false })
    }

    async showLife() {
        this.setState({ viewPersonal: false, viewLife: true })
    }

    public render() {
        let BreadcrumbDetails = [{ destination: DASHBOARD, description: "Home" }]
        let country = (this.props.profile.countryId === 244) ? "SA" : "Namibia";
        let nav = () =>
            <>
                <div id="RequestDocument">
                    <div className="col nopa ssp-request-docs-intro">
                        <h3>
                            Request a&nbsp;
                            <br className="ssp-request-docs-intro-break" />
                            document
                        </h3>
                        <p>Select the docs you need and we’ll email them to you</p>
                    </div>
                    <div className="col nopa ssp-request-docs-button-container">
                        {!this.props.ssp.livinEnabled &&
                            <>
                                <button className={"btn " + (this.state.viewPersonal ? 'btn-solid-red' : 'btn-outline-red')} onClick={this.showAll} >All docs</button>
                            </>
                        }
                        {this.props.ssp.livinEnabled &&
                            <>
                                {this.props.profile.isLinked && this.props.profile.isLifeLinked &&
                                    <>
                                        <button className={"btn " + (this.state.viewPersonal && (this.state.viewLife || !this.props.profile.isLifeLinked) ? 'btn-solid-red' : 'btn-outline-red')} onClick={this.showAll} >All docs</button>
                                    </>
                                }
                                {this.props.profile.isLinked &&
                                    <>
                                        <button className={"btn " + (this.state.viewPersonal && !this.state.viewLife ? 'btn-solid-red' : 'btn-outline-red')} onClick={this.showPersonal} >Personal policy docs</button>
                                    </>
                                }
                                {this.props.profile.isLifeLinked &&
                                    <>
                                        <button className={"btn " + (this.state.viewLife && !this.state.viewPersonal ? 'btn-solid-red' : 'btn-outline-red')} onClick={this.showLife}>Livin' policy docs</button>
                                    </>
                                }
                            </>
                        }
                    </div>
                </div>
            </>
        let docs = () => <>
            {this.state.viewPersonal &&
                <>
                    <div id="PersonalDocs" className="mb-2">
                        <div className="col-12 nopa ssp-personal-docs-container-outer">
                            <div className="ssp-docs-intro">
                                <h3>Personal policy docs</h3>
                            </div>
                            <div className="ssp-request-docs-document-list-container">
                                <div className="row noma ssp-request-docs-document-list-container-row">
                                    <div title="Policy schedule" className="col nopa ssp-request-docs-card" onClick={() => this.showRequestModal(DOC_POLICY_SCHEDULE)} id={DOC_POLICY_SCHEDULE}>
                                        <div className="row noma">
                                            <div className="ssp-request-docs-card-folder-col">
                                                <div className="ssp-request-docs-card-folder-icon"></div>
                                            </div>
                                            <div className="col nopa ssp-request-docs-card-content-col">
                                                <span className="ssp-request-docs-card-title">Policy schedule</span>
                                                <span className="ssp-request-docs-card-content">
                                                    Document confirming your policy and all items on cover
                                                </span>
                                            </div>
                                            <div className="ssp-request-docs-card-right-arrow-col">
                                                <div className="ssp-request-docs-card-right-arrow-icon"></div>
                                             </div>
                                        </div>
                                    </div>
                                    <div title="Policy document" className="col nopa ssp-request-docs-card ssp-request-docs-card-policy-doc"  onClick={() => this.showRequestModal(DOC_KPPD_COVER)} id={DOC_KPPD_COVER}>
                                        <div className="row noma">
                                            <div className="ssp-request-docs-card-folder-col">
                                                <div className="ssp-request-docs-card-folder-icon"></div>
                                            </div>
                                            <div className="col nopa ssp-request-docs-card-content-col">
                                            <span className="ssp-request-docs-card-title">Policy document</span>
                                                <span className="ssp-request-docs-card-content">
                                                    This explains your cover, the finer details of your policy and your KPPD
                                                    (King Price Policy Document)
                                                </span>
                                            </div>
                                            <div className="ssp-request-docs-card-right-arrow-col">
                                                <div className="ssp-request-docs-card-right-arrow-icon"></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="row noma ssp-request-docs-document-list-container-row">
                                    <div title="Confirmation of cover" className="col nopa ssp-request-docs-card" onClick={() => this.showRequestModal(DOC_CONFIRMATION_OF_COVER)} id={DOC_CONFIRMATION_OF_COVER}>
                                        <div className="row noma">
                                            <div className="ssp-request-docs-card-folder-col">
                                                <div className="ssp-request-docs-card-folder-icon"></div>
                                            </div>
                                            <div className="col nopa ssp-request-docs-card-content-col">
                                                <span className="ssp-request-docs-card-title">Confirmation of cover</span>
                                                <span className="ssp-request-docs-card-content">
                                                    Document confirming that 1 of your items is covered by the king
                                                 </span>
                                            </div>
                                            <div className="ssp-request-docs-card-right-arrow-col">
                                                <div className="ssp-request-docs-card-right-arrow-icon"></div>
                                            </div>
                                        </div>
                                    </div>
                                    <div title="Summary of cover" className="col nopa ssp-request-docs-card" onClick={() => this.showRequestModal(DOC_SUMMARY_OF_COVER)} id={DOC_SUMMARY_OF_COVER}>
                                        <div className="row noma">
                                            <div className="ssp-request-docs-card-folder-col">
                                                <div className="ssp-request-docs-card-folder-icon"></div>
                                            </div>
                                            <div className="col nopa ssp-request-docs-card-content-col">
                                                <span className="ssp-request-docs-card-title">Summary of cover</span>
                                                <span className="ssp-request-docs-card-content">
                                                    This lists the items that we’re covering for you
                                                </span>
                                            </div>
                                            <div className="ssp-request-docs-card-right-arrow-col">
                                                <div className="ssp-request-docs-card-right-arrow-icon"></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="row noma ssp-request-docs-document-list-container-row">
                                <div title="Tax certificate" className="col nopa ssp-request-docs-card" onClick={() => this.showRequestModal(DOC_TAX_INVOICE)} id={DOC_TAX_INVOICE}>
                                        <div className="row noma">
                                            <div className="ssp-request-docs-card-folder-col">
                                                <div className="ssp-request-docs-card-folder-icon"></div>
                                            </div>
                                            <div className="col nopa ssp-request-docs-card-content-col">
                                            <span className="ssp-request-docs-card-title">Tax certificate</span>
                                                <span className="ssp-request-docs-card-content">
                                                    This lists the tax amounts for specific items
                                                </span>
                                            </div>
                                            <div className="ssp-request-docs-card-right-arrow-col">
                                                <div className="ssp-request-docs-card-right-arrow-icon"></div>
                                            </div>
                                        </div>
                                    </div>
                                    <div title="Cross border letter" className="col nopa ssp-request-docs-card" onClick={() => this.showRequestModal(DOC_CROSS_BORDER_LETTER)} id={DOC_CROSS_BORDER_LETTER}>
                                        <div className="row noma">
                                            <div className="ssp-request-docs-card-folder-col">
                                                <div className="ssp-request-docs-card-folder-icon"></div>
                                            </div>
                                            <div className="col nopa ssp-request-docs-card-content-col">
                                                <span className="ssp-request-docs-card-title">Cross border letter</span>
                                                <span className="ssp-request-docs-card-content">
                                                    Going out of {country} with your car? You’ll need this letter
                                                </span>
                                            </div>
                                            <div className="ssp-request-docs-card-right-arrow-col">
                                                <div className="ssp-request-docs-card-right-arrow-icon"></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            }
            {this.props.lifePolicy.enabled && this.state.viewLife &&
                <>
                <div id="LifeDocs">
                    <div className="col-12 nopa ssp-personal-docs-container-outer">
                        <div className="ssp-docs-intro">
                            <h3>Livin' policy docs</h3>
                        </div>
                        <div className="ssp-request-docs-document-list-container">
                            <div className="row noma ssp-request-docs-document-list-container-row">
                                {/*/// Note to Livin' dev: Policy schedule needs Modal ///*/}
                                <div title="Policy schedule" className="col nopa ssp-request-docs-card" onClick={() => this.showRequestModal("INSERT MODAL")} id="Insert ID">
                                    <div className="row noma">
                                        <div className="ssp-request-docs-card-folder-col">
                                            <div className="ssp-request-docs-card-folder-icon"></div>
                                        </div>
                                        <div className="col nopa ssp-request-docs-card-content-col">
                                            <span className="ssp-request-docs-card-title">Policy schedule</span>
                                            <span className="ssp-request-docs-card-content">
                                                Document confirming your policy and all items on cover
                                            </span>
                                        </div>
                                        <div className="ssp-request-docs-card-right-arrow-col">
                                            <div className="ssp-request-docs-card-right-arrow-icon"></div>
                                        </div>
                                    </div>
                                </div>

                                {/*/// Note to Livin' dev: Summary of cover Modal ///*/}
                                <div title="Summary of cover" className="col nopa ssp-request-docs-card" onClick={() => this.showRequestModal("INSERT MODAL")} id="Insert ID">
                                    <div className="row noma">
                                        <div className="ssp-request-docs-card-folder-col">
                                            <div className="ssp-request-docs-card-folder-icon"></div>
                                        </div>
                                        <div className="col nopa ssp-request-docs-card-content-col">
                                            <span className="ssp-request-docs-card-title">Summary of cover</span>
                                            <span className="ssp-request-docs-card-content">
                                                This lists the items that we're covering for you
                                            </span>
                                        </div>
                                        <div className="ssp-request-docs-card-right-arrow-col">
                                            <div className="ssp-request-docs-card-right-arrow-icon"></div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="row noma ssp-request-docs-document-list-container-row">
                                <div title="Policy document" className="col nopa ssp-request-docs-card ssp-request-docs-card-policy-doc" onClick={() => this.showRequestModal(DOC_LIFE_POLICY_DOCUMENT)} id={DOC_LIFE_POLICY_DOCUMENT}>
                                    <div className="row noma">
                                        <div className="ssp-request-docs-card-folder-col">
                                            <div className="ssp-request-docs-card-folder-icon"></div>
                                        </div>
                                        <div className="col nopa ssp-request-docs-card-content-col">
                                            <span className="ssp-request-docs-card-title">Policy document</span>
                                            <span className="ssp-request-docs-card-content">
                                                This explains your cover, the finer details of your policy and your KPPD (King Price Policy Document)
                                            </span>
                                        </div>
                                        <div className="ssp-request-docs-card-right-arrow-col">
                                            <div className="ssp-request-docs-card-right-arrow-icon"></div>
                                        </div>
                                    </div>
                                </div>

                                <div title="empty card" className="nopa col ssp-request-docs-card ssp-request-docs-card-empty">
                                    <div className="row noma">
                                        <div className="ssp-request-docs-card-folder-col">
                                            <div className="ssp-request-docs-card-folder-icon"></div>
                                        </div>
                                        <div className="col nopa ssp-request-docs-card-content-col">
                                            <span className="ssp-request-docs-card-title">Empty card</span>
                                            <span className="ssp-request-docs-card-content">
                                                Empty card to maintain layout integrity 
                                            </span>
                                        </div>
                                        <div className="ssp-request-docs-card-right-arrow-col">
                                            <div className="ssp-request-docs-card-right-arrow-icon"></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                </>
            }
        </>
        return (
            <>
                <div id="RequestDocuments" className="container-fluid new-page-margins">
                    <div className="new-breadcrumbwrapper breadcrumb-wrapper-contact-us">
                        <KPBreadCrumb navList={BreadcrumbDetails} activePage="Request a document" />
                    </div>
                    <div className="row new-page-main-row">
                        <div className="col nopa ssp-request-docs-left-col">
                            {nav()}
                        </div>
                        <div className="col nopa ssp-request-docs-right-col">
                            <hr className="ssp-request-docs-mobile-divider-line" />
                            {docs()}
                        </div>
                    </div>
                </div>
            </>
        )
    }
}

const mapStateToProps = (state: any) => {
    return {
        profile: state.profile,
        ssp: state.ssp,
        lifePolicy: state.lifePolicy,
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        dispatchHideProfile: () => dispatch(hideMobileProfile()),
        dispatchShowRequestDocuments: (documentName: string, documentId: string) => dispatch(showRequestDocuments(documentName, documentId)),
        dispatchShowBrokerPopup: () => dispatch(showBrokerPopup())
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(RequestDocuments);